var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PageButton(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.style, style = _c === void 0 ? {} : _c, _d = _a.onClick, onClick = _d === void 0 ? function () {
        return;
    } : _d;
    return (_jsx("svg", __assign({ onClick: onClick, className: className, style: style, xmlns: 'http://www.w3.org/2000/svg', width: '32', height: '32', viewBox: '0 0 32 32' }, { children: _jsx("g", __assign({ fill: 'none', "fill-rule": 'evenodd' }, { children: _jsx("g", { children: _jsx("g", { children: _jsx("g", { children: _jsx("g", { children: _jsxs("g", __assign({ transform: 'translate(-1212 -1172) translate(0 1156) translate(923 16) translate(105) translate(184)' }, { children: [_jsx("rect", { width: '31', height: '31', x: '.5', y: '.5', stroke: '#DADCE0', "stroke-opacity": '.5', rx: '5' }, void 0),
                                    _jsx("path", { fill: '#666', d: 'M21.85 17.638l-4.488-4.488c-.2-.2-.524-.2-.724 0l-4.488 4.488c-.2.2-.2.524 0 .724l.361.361c.2.2.524.2.724 0L17 14.957l3.766 3.766c.2.2.523.2.723 0l.361-.361c.2-.2.2-.524 0-.724z', transform: 'matrix(0 -1 -1 0 32.936 32.936)' }, void 0)] }), void 0) }, void 0) }, void 0) }, void 0) }, void 0) }), void 0) }), void 0));
}
